import commonJsModule from "readable-ms"

export default commonJsModule.default